export const errors = {
    required: 'Valid amount required',
    minLength: 'Please enter amount $',
    maxLength: 'Please enter amount $',
    invalid: 'Sorry, that\'s an invalid entry. Max amount = $'
};
